/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Result_Action_DescriptionInputs */



/**
* | output |
* | --- |
* | "A step the agent takes with its result, through the connection the agent uses. It follows the agent's approval setting. Only apps you have connected are list..." |
*
* @param {Agent_Builder_Result_Action_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_description = /** @type {((inputs?: Agent_Builder_Result_Action_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Schritt, den der Agent mit seinem Ergebnis ausführt, über die Verbindung, die der Agent nutzt. Er folgt der Freigabe-Einstellung des Agenten. Es werden nur Apps angezeigt, die Sie verbunden haben, und ein Datensatz-Schritt bietet nur Datensätze an, in die Sie schreiben dürfen.")
	return /** @type {LocalizedString} */ ("A step the agent takes with its result, through the connection the agent uses. It follows the agent's approval setting. Only apps you have connected are listed, and a dataset step lists only datasets you can write to.")
});